<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item>班级管理</el-breadcrumb-item>
      <el-breadcrumb-item>1对1班级</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
        <el-row :gutter="24">
          <el-col :span="4">
            <el-input
              v-model="classOneOnOnePageParamVO.name"
              placeholder="请输入班级名称"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-select v-model="classOneOnOnePageParamVO.schedule" placeholder="请选择老师" clearable>
              <el-option
                v-for="item in teacherList"
                :key="item.id"
                :label="item.realname"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
<!--          <el-col :span="4">-->
<!--            <el-select v-model="classOneOnOnePageParamVO.sort" placeholder="排序">-->
<!--              <el-option-->
<!--                v-for="item in sortList"-->
<!--                :key="item.value"-->
<!--                :label="item.label"-->
<!--                :value="item.value">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-col>-->
          <el-col :span="5">
        <el-button @click="getOneClassList" type="primary">搜索</el-button>
        <el-button @click="handleAddOne" type="success">新增</el-button>
      </el-col>
        </el-row>
        <el-table :data="oneClassList" stripe>
          <el-table-column type="index"></el-table-column>
          <el-table-column label="班级名称" prop="className" width="170px"></el-table-column>
          <el-table-column  label="班级课节数"  prop="classNum" width="95px"></el-table-column>
          <el-table-column label="开班时间" prop="startDates" width="100px"></el-table-column>
          <el-table-column  label="当前课程"  prop="courseName" width="170px"></el-table-column>
          <el-table-column  label="上课老师"  prop="teacherName" width="95px"></el-table-column>
          <el-table-column label="扣除课次类型" prop="deductType" width="115px">
            <template slot-scope="scope">
              <span>{{scope.row.deductType==1?'次数':'时长（小时）'}}</span>
            </template>
          </el-table-column>
          <el-table-column  label="扣除数量"  prop="deductTimes" width="95px"></el-table-column>
          <el-table-column label="操作" width="325px">
            <template slot-scope="scope">
              <el-button @click="handleEdit(scope.row,'oneClass')" type="text" style="color:#FF9F00">编辑</el-button>
              <el-button @click="handleDelete(scope.row,'oneClass')" type="text" style="color:#F53F3F">删除</el-button>
              <el-button @click="addStudent(scope.row,'oneClass')" type="text" style="color:#13C2C2">添加学员</el-button>
              <el-button @click="detailStudent(scope.row,'oneClass')" type="text" style="color:#3E82F5">查看学员</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 页数码 -->
        <el-pagination
          @current-change="handleCurrentOneClassChange"
          @size-change="handleSizeChangeOneClass"
          :current-page.sync="classOneOnOnePageParamVO.pageNo"
          :page-size="classOneOnOnePageParamVO.pageSize"
          :total="oneClassDataTotal"
          background
        ></el-pagination>
    </el-card>
    <!-- 添加学员 -->
    <el-dialog title="添加学员" :visible.sync="dialogVisibleAddStudent" width="90%" :close-on-click-modal="false">
      <el-form :model="studentPageParamVO">
        <el-row :gutter="24">
          <el-col :span="4">
            <el-form-item label="">
              <el-input placeholder="输入手机号，姓名" v-model="studentPageParamVO.realnameOrPhone" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="" prop="grade">
              <el-select v-model="studentPageParamVO.grade" placeholder="年级" clearable>
                <el-option
                  v-for="item in gradeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="" prop="subject">
              <el-select v-model="studentPageParamVO.subject" placeholder="科目" clearable>
                <el-option
                  v-for="item in subjectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
<!--          <el-col :span="4">-->
<!--            <el-form-item label="">-->
<!--              <el-select v-model="studentPageParamVO.isSchedule" placeholder="是否排课" clearable>-->
<!--                <el-option label="已排课" value="2"></el-option>-->
<!--                <el-option label="未排课" value="1"></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="3">
            <el-form-item label="">
              <el-button @click="getStudentClassList" type="primary">搜索</el-button>
            </el-form-item>
          </el-col>
<!--          <el-col :span="3">-->
<!--            <el-form-item label="">-->
<!--              <el-button @click="handleBatchAdd" type="success">批量添加</el-button>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-row>
      </el-form>
      <el-table :data="studentList" @selection-change="handleSelectionStudent" stripe>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column property="realname" label="学员姓名"></el-table-column>
        <el-table-column property="phone" label="手机号码"></el-table-column>
        <el-table-column property="grade" label="年级"></el-table-column>
        <el-table-column property="school" label="就读学校"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.currentClassJoinFlag == 0" @click="handleAddStudent(scope.row)" type="text">添加</el-button>
            <span v-else>已添加</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 页数码 -->
          <el-pagination
            @current-change="handleCurrentStudentChange"
            @size-change="handleSizeChangeStudent"
            :current-page.sync="studentPageParamVO.pageNo"
            :page-size="studentPageParamVO.pageSize"
            :total="studentDataTotal"
            background
          ></el-pagination>
      <div slot="footer" class="dialog-footer">
       <el-button @click="dialogVisibleAddStudent = false">取 消</el-button>
       <!-- <el-button type="primary" @click="dialogVisibleAddStudent = false">确 定</el-button> -->
      </div>
    </el-dialog>
    <!-- 确定添加学员 -->
    <el-dialog title="确定添加学员" :visible.sync="dialogVisibleConfirmAddStudent" :close-on-click-modal="false">
<!--      <el-form :model="classRelateStudentModel">-->
<!--        <el-form-item label="选择具体上课时间" label-width="150px">-->
<!--          <el-select v-model="classRelateStudentModel.classScheduleId" placeholder="选择具体上课时间">-->
<!--            <el-option :label="item.label" :value="item.value" v-for="(item,index) in timeList" :key="index"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleConfirmAddStudent = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddStudent">确定</el-button>
      </div>
    </el-dialog>
    <!-- 生成上课记录 -->
    <el-dialog title="确定生成上课记录" :visible.sync="dialogVisibleClassRecord" :close-on-click-modal="false">
      <el-form :model="classRecordModel">
        <el-form-item label="选择日期" label-width="150px">
          <el-date-picker
            v-model="classRecordModel.startDates"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleClassRecord = false">取 消</el-button>
        <el-button type="primary" @click="confirmGenerateRecord">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { formatDate } from "../../../plugins/date.js";
  export default {
    data() {
      return {
        activeName:'first',
        // 老师列表
        teacherList:[],
        // 状态列表
        statusList:[
          {
            value:'1',
            label:'未排课',
          },
          {
            value:'2',
            label:'已排课',
          }
        ],
        // 排序列表
        sortList:[
          {
            value:'1',
            label:'开班时间升序'
          },
          {
            value:'2',
            label:'开班时间降序'
          }
        ],
        //用于获取班级数据列表
        classClassPageParamVO: {
          name: '',
          sort:null,
          pageSize: 10,
          pageNo: 1,
          status:null,
          teacherId:''
        },
        // 用于获取一对一班级数据列表
        classOneOnOnePageParamVO:{
          name: '',
          sort:null,
          pageSize: 10,
          pageNo: 1,
          status:null,
          teacherId:''
        },
        // 用于获取学员列表
        studentPageParamVO:{
          classId:'',
          classScheduleId:'',
          classType:'',
          isSchedule:null,
          grade: null,
          subject: '',
          pageNo:1,
          pageSize:10,
          realnameOrPhone:'',
          studentSelectFlag:''
        },
        timeList:[],//添加学员排课具体上课时间列表
        // 班级添加学员
        classRelateStudentModel:{
          classId:'',
          studentIds:'',
          classScheduleId:''
        },
        gradeList: [{id: 2,name: '二年级'},
          {id: 3,name: '三年级'},
          {id: 4,name: '四年级'},
          {id: 5,name: '五年级'},
          {id: 6,name: '六年级'},
          {id: 7,name: '七年级'},
          {id: 8,name: '八年级'},
          {id: 9,name: '九年级'},
          {id: 10,name: '高一'},
          {id: 11,name: '高二'},
          {id: 12,name: '高三'}],
        subjectList: [{id: 1,name: '数学'},
          {id: 2,name: '语文'},
          {id: 3,name: '英语'},
          {id: 4,name: '科学'},
          {id: 5,name: '物理'},
          {id: 6,name: '化学'},
          {id: 7,name: '生物'}],
        // 班级列表
        classList: [],
        // 班级列表总数
        classDataTotal:0,
        // 一对一班级列表
        oneClassList:[],
        oneClassDataTotal:0,
        // 学员列表
        studentList:[],
        studentDataTotal:0,
        total: 0,
        dialogVisibleAddStudent:false,
        dialogVisibleClassRecord:false,
        classRecordModel:{
          ctype: '',
          classId: '',
          courseId: '',
          startDates: ''
        },
        // 批量选择学员列表
        selectStudentList:[],
        // 确定添加学员弹窗参数
        confirmstudentPageParamVO:{
          name:'',
        },
        // 确定添加学员弹窗隐藏/显示
        dialogVisibleConfirmAddStudent:false,
      };
    },
    created() {
      // this.initTab();
      this.getClassList();
      this.getOneClassList();
      this.getTeacherList();
    },
    filters: {
      formatDate(time) {
        var date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },
    },
    methods: {
      // initTab() {
      //   this.$route.params.tab
      // },
      // 获取班级列表
      async getClassList() {
        const { data: res } = await this.$http.post("/ea/student/classClass/list",this.classClassPageParamVO);
          if (res.code !== 200)
            return this.$message.error(res.data.message);
            this.classList = res.result.records;
            this.classDataTotal = res.result.total;
      },
      // 获取一对一班级列表
      async getOneClassList() {
        const { data: res } = await this.$http.post("/ea/student/classOneOnOne/list",this.classClassPageParamVO);
          if (res.code !== 200)
            return this.$message.error(res.data.message);
            this.oneClassList = res.result.records;
            this.oneClassDataTotal = res.result.total;
      },
      // 获取学员列表
      async getStudentClassList() {
        const { data: res } = await this.$http.post("/ea/student/student/list",this.studentPageParamVO);
          if (res.code !== 200)
            return this.$message.error(res.data.message);
            this.studentList = res.result.records;
            this.studentDataTotal = res.result.total;
      },
      // 获取所有授课老师
      async getTeacherList() {
        this.courseList = [];
        const { data: res } = await this.$http.get(`/ea/sys/user/getTeacherList`);
        if (res.code !== 200)
        return this.$message.error(res.message);
        this.teacherList = res.result;
      },
      // 查看详情
      handleDetail(row,type){
        // 班课班级详情
        if(type == 'class'){
          this.$router.push({
            path:'studentDetail',
            query: {
                classId:row.id,
                classType:2
            }
          })
        }
        // 一对一详情
        else{
          this.$router.push({
            path:'studentDetail',
            query: {
                classId:row.id,
                classType:1
            }
          })
        }
      },
      // 班级搜索
      handleClassSearch(){
        this.classClassPageParamVO.pageSize = 10;
        this.classClassPageParamVO.pageNo = 1;
        // this.getTeacherList();
      },
      // 班级列表切换页码
      handleCurrentClassChange(page) {
        this.classClassPageParamVO.pageNum = page;
        this.getClassList();
      },
      handleSizeChangeClass(pageSize){
        this.classClassPageParamVO.pageSize = pageSize;
        this.getClassList();
      },
      // 一对一班级列表切换页码
      handleCurrentOneClassChange(page) {
        this.classOneOnOnePageParamVO.pageNum = page;
        this.getOneClassList();
      },
      handleSizeChangeOneClass(pageSize){
        this.classOneOnOnePageParamVO.pageSize = pageSize;
        this.getOneClassList();
      },
      // 学员列表切换页码
      handleCurrentStudentChange(page) {
        this.studentPageParamVO.pageNum = page;
        this.getStudentClassList();
      },
      handleSizeChangeStudent(pageSize){
        this.studentPageParamVO.pageSize = pageSize;
        this.getStudentClassList();
      },
      // 新增班级
      handleAdd(){
        this.$router.push("/createClass");
      },
      handleEdit(record,type){
        if(type=='class'){
          this.$router.push({
            name: "createClass",
            params: {recordDate:record,type:'edit'}
          });
        }else{
          this.$router.push({
            name: "createOneByOne",
            params: {recordDate:record,type:'edit'}
          });
        }
      },
      // 添加学员
      addStudent(row,type){
        this.classRelateStudentModel.classId = row.id;
        if(type=='oneClass'){
          this.studentPageParamVO.classType = 1;
          this.studentPageParamVO.classId = row.id;
          this.studentPageParamVO.studentSelectFlag = 1;
        }
        // this.queryScheduleById(row);
        this.studentPageParamVO.realnameOrPhone = '';
        this.studentPageParamVO.isSchedule = '';
        this.getStudentClassList();
        this.dialogVisibleAddStudent = true;
      },
      generateRecord(row, type){
        this.classRecordModel.id = row.id;
        this.classRecordModel.ctype = type;
        this.classRecordModel.courseId = row.courseId;
        this.dialogVisibleClassRecord = true;
      },
      async confirmGenerateRecord(){
        let url = `/ea/student/classOneOnOne/generateRecord`;
        if(this.classRecordModel.ctype == "class"){
          url = `/ea/student/classClass/generateRecord`;
        }
        const { data: res } = await this.$http.post(url,this.classRecordModel);
        if (res.code !== 200){
          return this.$message.error(res.message);
        }else{
          this.dialogVisibleClassRecord = false;
          return this.$message.success(res.message);
        }
      },
       // 班级排课查询
      async queryScheduleById(row){
        this.timeList = [];
        let id = row.id;
        let idModel = {
          id:id,
        };
        const { data: res } = await this.$http.post(`/ea/student/classClass/queryScheduleById`,idModel);
        if (res.code !== 200)
        return this.$message.error(res.message);
        let list  = res.result;
        list.map(e=>{
          let item = {
            label:e.startDates+'/'+e.beginTime+'-'+e.startDates+'/'+e.endTime,
            value:e.id
          };
          this.timeList.push(item);
        })
      },
      // 查看学员
      detailStudent(row,type){
        // 班课班级详情
        if(type == 'class'){
          this.$router.push({
            path:'classStudentDetail',
            query: {
                classId:row.id,
                classType:2
            }
          })
        }else{
          this.$router.push({
            path:'classStudentDetail',
            query: {
                classId:row.id,
                classType:1
            }
          })
        }
      },
      // 选择班级tab切换
      handleClick(tab, event) {
        console.log(tab, event);
      },
      // 删除班级
      handleDelete(row,type){
        // 班课班级删除
        if(type=='class'){
          this.$confirm('此操作将永久删除该班课班级, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.deleteClass(row);
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
        // 一对一班级删除
        else{
          this.$confirm('此操作将永久删除该1对1班级, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.deleteOneClass(row);
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
      // 班课班级删除
      async deleteClass(row){
        let idModel = {
          id:row.id
        }
        const { data: res } = await this.$http.post(`/ea/student/classClass/delete`,idModel);
        if (res.code !== 200)
        return this.$message.error(res.message);
        this.$message({
          type: 'success',
          message: res.message
        });
        this.getClassList();
      },
      // 一对一删除
      async deleteOneClass(row){
        let idModel = {
          id:row.id
        }
        const { data: res } = await this.$http.post(`/ea/student/classOneOnOne/delete`,idModel);
        if (res.code !== 200)
        return this.$message.error(res.message);
        this.$message({
          type: 'success',
          message: res.message
        });
        this.getOneClassList();
      },
      // 批量选择学员
      handleSelectionStudent(val){
        this.selectStudentList = val;
        let list = [];
        this.selectStudentList.map(e=>{
          list.push(e.id);
        })
        this.classRelateStudentModel.studentIds = list.toString();
      },
      // 批量添加学员
      handleBatchAdd(){
        this.classRelateStudentModel.classScheduleId = '';
        this.dialogVisibleConfirmAddStudent = true;
      },
      // 添加学员
      handleAddStudent(row){
        this.classRelateStudentModel.studentIds = row.id;
        this.dialogVisibleConfirmAddStudent = true;
      },
      // 确定添加学员
      async confirmAddStudent(){
        const { data: res } = await this.$http.post(`/ea/student/classClass/addStudent`,this.classRelateStudentModel);
        if (res.code !== 200)
        return this.$message.error(res.message);
        this.$message({
          type: 'success',
          message: res.message
        });
        this.getStudentClassList();
        this.dialogVisibleConfirmAddStudent = false;
      },
      // 新增一对一班级
      handleAddOne(){
        this.$router.push("/createOneByOne");
      },
      handleSearch(){}
    },
  };
</script>

<style lang="less" scoped>

</style>
